import { RangeFilter } from './custom-filter-range.model';

export const allAgeGroupsLabel: string = 'All age groups';

export class AgeGroup {
  constructor(
    public greaterThan?: number,
    public lessThan?: number,
    public name?: string,
    public disabled: boolean = false,
    public id?: number,
    public authDisabled?: boolean,
    public preview?: boolean,
    public selected?: boolean
  ) {}

  public static from(rangeFilter: RangeFilter) {
    return new AgeGroup(
      rangeFilter.greaterThan,
      rangeFilter.lessThan,
      rangeFilter.name,
      false,
      rangeFilter.id
    );
  }

  public displayValue(): string {
    if (this.compactDisplayValue() === allAgeGroupsLabel) {
      return this.compactDisplayValue();
    }

    return `${this.compactDisplayValue()} Years`;
  }

  public compactDisplayValue(): string {
    if (this.greaterThan !== undefined && this.lessThan != undefined) {
      return `${this.greaterThan}-${this.lessThan}`;
    }

    if (this.greaterThan !== undefined) {
      return `>${this.greaterThan}`;
    }

    if (this.lessThan !== undefined) {
      // is this even a usecase?
      return `<${this.lessThan}`;
    }

    return allAgeGroupsLabel;
  }
}
